<template>
  <section>
    <h1 class="title has-text-primary">
      Manage Missions
    </h1>

    <section>

      <b-table
        :data="missions.data"
        :selected.sync="missions.selected"
      >
        <template slot-scope="props">
          <b-table-column field="name" label="Name" sortable>
            {{ props.row.name }}
          </b-table-column>
          <b-table-column field="donationFee" label="Donation Fee" sortable>
            ${{ props.row.donationFee || 0 }}
          </b-table-column>
          <b-table-column field="country" label="Country" sortable>
            {{ props.row.country }}
          </b-table-column>
          <b-table-column field="isVisible" label="Is Visible?" sortable>
            {{ props.row.isVisible ? 'Yes' : 'No' }}
          </b-table-column>
          <b-table-column field="isSignUpEnabled" label="Sign Up Enabled?" sortable>
            {{ props.row.isSignUpEnabled ? 'Yes' : 'No' }}
          </b-table-column>
          <b-table-column field="fromDate" label="From Date" sortable centered>
            {{ new Date(props.row.fromDate).toLocaleDateString() }}
          </b-table-column>
          <b-table-column field="toDate" label="End Date" sortable centered>
            {{ new Date(props.row.toDate).toLocaleDateString() }}
          </b-table-column>

        </template>
      </b-table>

      <br/>
      <section>
        <div class="buttons">
          <button class="button is-danger" @click="confirmDeleteMission(missions.selected.missionId)"
                  :disabled="!missions.selected">
            Delete
          </button>
          <button class="button is-primary" @click="checkMissionGoers(missions.selected.missionId, missions.selected.name)"
                  :disabled="!missions.selected">
            Check Mission Goers
          </button>
          <button class="button is-info" @click="editMission(missions.selected.missionId)"
                  :disabled="!missions.selected">
            Edit
          </button>
        </div>
      </section>

    </section>
  </section>
</template>

<script>
export default {
  mounted() {
    this.axios.get(
      'https://mc0m0fa550.execute-api.us-east-1.amazonaws.com/dev/missions',
    )
      .then((res) => {
        this.missions.data = res.data;
      });
  },
  methods: {
    editMission(missionId) {
      this.$router.push({
        name: 'edit-mission',
        params: { missionId },
      });
    },
    checkMissionGoers(missionId, missionName) {
      this.$router.push({
        name: 'mission-goers',
        params: { missionId },
        query: { missionName },
      });
    },
    confirmDeleteMission() {
      const { name } = this.missions.selected;
      this.$dialog.confirm({
        title: `Delete ${name}?`,
        message: `Are you sure you want to delete <b>${name}</b>? This action cannot be undone.`,
        confirmText: `Delete ${name}`,
        type: 'is-danger',
        onConfirm: () => {
          const { missionId } = this.missions.selected;
          this.axios.delete(
            `https://mc0m0fa550.execute-api.us-east-1.amazonaws.com/dev/mission/${missionId}`,
          )
            .then(() => {
              this.missions.data.forEach((mission, index, arr) => {
                if (mission.missionId === missionId) this.data = arr.splice(index, 1);
              });
              this.$toast.open(`<b>${name}</b> deleted!`);
            });
        },
      });
    },
  },
  data() {
    return {
      missions: {
        data: [],
        selected: null,
      },
    };
  },
};
</script>
